import { useState, useEffect } from "react";

// Constants
export const MOBILE_BREAKPOINT = 768;

/**
 * Helper function to construct full image URL from relative or partial paths
 * @param {string} imageUrl - The image URL (can be relative, partial, or full)
 * @returns {string|null} - The full image URL or null if no imageUrl provided
 */
export const getFullImageUrl = (imageUrl) => {
  if (!imageUrl) return null;

  // If it's already a full URL (starts with http/https), return as is
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }

  const baseUrl = process.env.REACT_APP_INVENIO_UI_URL;

  // Handle URLs that don't start with /api/
  let fullPath = imageUrl;
  if (imageUrl.startsWith("/profile/")) {
    fullPath = `/api${imageUrl}`; // Add /api prefix
  } else if (imageUrl.startsWith("/") && !imageUrl.startsWith("/api/")) {
    fullPath = `/api${imageUrl}`;
  } else if (!imageUrl.startsWith("/api/") && !imageUrl.startsWith("/")) {
    fullPath = `/api/${imageUrl}`;
  }

  return `${baseUrl.replace(/\/$/, "")}${fullPath}`;
};

/**
 * Custom hook for detecting mobile screen sizes
 * @returns {boolean} - True if screen width is <= MOBILE_BREAKPOINT
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.innerWidth <= MOBILE_BREAKPOINT
      : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () =>
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};
